const TimerStatus = {
    stopped: 'stopped',
    started: 'started',
    paused: 'paused',
    resumed: 'resumed',
};

const TimerAction = {
    start: 'start',
    stop: 'stop',
    pause: 'pause',
};

const EventType = {
    start: 'start',
    stop: 'stop',
};

export {
    TimerStatus,
    TimerAction,
    EventType,
};

